// extracted by mini-css-extract-plugin
var _1 = "ControlTime-moduleinputWrap__Z7GWc TimeInput-moduleTimeInputWrap__MeJx4 InputWrap-moduleInputWrap__X8g8b";
export { _1 as "inputWrap" }
